<template>
  <div>
    {{ formatNumber(object.limit_used, false, '0') }} / {{ formatNumber(object.polis_limit, false, '0') }}
  </div>
</template>

<script setup>
import { formatNumber } from "@/extensions/filters/filters"

defineProps({
  object: {
    type: Object
  },
})
</script>
